const es = {
    9000001: "Trofeo de Navidad 2023",
    9000002: "Campeonato de Futuros SuperEx",
    9000003: "gane 30,000 USDT en premios del concurso",
    9000004: "Número de participantes",
    9000005: "Fondo de premios desbloqueado (USDT)",
    9000006: "Clasificación de Volumen de Negociación",
    9000007: "Clasificación de la Competencia de la Tasa de Beneficio",
    9000008: "Competición de Clasificación del Ránking de Ganancias ",
    9000009: `Competencia de clasificación de volumen de negociación: Desbloquee el premio más alto del fondo de bonos de <span style="color: #ffc72b;">20,000</span> USDT`,
    9000010: "Según el número de participantes, cuanto mayor sea el número de participantes, mayor será el premio, hasta 20 000 USDT",
    9000011: "Monto del fondo de premios",
    9000012: "Actualizaciones diarias a las 10:00 (UTC) durante el evento",
    9000013: "Estimación de recompensas",
    9000014: "Volumen total de comercio de futuros durante el período",
    9000015: "Reglas de recompensas",
    9000016: "Según el número de participantes, cuanto mayor sea el número de participantes, mayor será el premio, hasta 20 000 USDT",
    9000017: "Monto del fondo de premios (USDT)",
    9000018: "Clasificación de la tasa de beneficio del evento",
    9000019: "Inscripción",
    9000020: "Clasificación del monto de beneficio del evento",
    9000021: "Terminado",
    9000022: `Clasificación de la competencia de la tasa de ganancias - Disfruta de un bono de <span style="color: #ffc72b;">{moneyPond}</span> USDT `,
    9000023: `Ránking de Competición de Ganancias - Disfruta <span style="color: #ffc72b;">{moneyPond}</span> USDT en Bonus`,
    9000024: "Margen de beneficio acumulado de futuros",
    9000025: "Monto de beneficio acumulado de futuros",
    9000026: "No ha empezado",
    9000027: "Los 50 mejores participantes en la competencia de clasificación de beneficios serán recompensados. Para obtener más información, consulte las Reglas de Recompensa de Clasificación para obtener las recompensas.",
    9000028: "Los 50 mejores participantes en términos de rentabilidad serán recompensados, consulte las Reglas de Recompensa de la Clasificación de Operaciones para obtener la recompensa",
    9000029: "Clasificación del volumen de comercio del evento",
    9000030: "Registro exitoso",
    9000031: "Descargar la aplicación",
    9000032: "De vuelta a casa",

    //合约交易积分
    9100001: 'Guardar Puntos',
    9100002: 'Obtener Airdrop',
    9100003: 'Canjear Recompensas',
    9100004: 'Saldo de puntos',
    9100005: 'Información interna',
    9100006: 'Puntos de inicio de sesión',
    9100007: 'Puntos de Trading',
    9100008: 'Puntos de invitación',
    9100009: 'Puntos de bonificación',
    9100010: 'Sorteo de la suerte',
    9100011: 'Consigue puntos',
    9100012: 'Regla de puntos',
    9100013: 'Detalles de los puntos',
    9100014: 'Tienes que registrarte para participar en este evento. Haga clic para registrarse',
    9100015: 'Has negociado durante {day} días consecutivos y has ganado {num} puntos',
    9100016: 'Reglas de puntos',
    9100017: 'Premio de puntos',
    9100018: 'Cada sorteo de la suerte consume {point} puntos, y se puede sortear el máximo de {num} veces de sorteo por día.',
    9100019: 'Número de sorteos de la suerte de hoy',
    9100020: 'Usuario',
    9100021: 'Puntos',
    9100022: 'El saldo de puntos es insuficiente',
    9100023: 'El saldo de puntos es insuficiente. Por favor, obtenga puntos antes de participar en el sorteo de la suerte.',
    9100024: '¡El número de sorteos de la suerte alcanzó su límite!',
    9100025: 'El número de sorteos de la suerte de hoy alcanzó su límite. Inténtalo de nuevo mañana.',
    9100026: 'Cómo ganar puntos',
    9100027: 'Regístrese y participe en la actividad de negociación de contratos de puntos y gane puntos.',
    9100028: 'Registro exitoso',
    9100029: 'Te has registrado para participar en la actividad de comercio de futuros para ganar puntos. Ve y comercia para ganar más puntos (ya no disfrutarás de la comisión y las recompensas de devolución de dinero)',
    9100030: 'Después de cancelar su registro, ya no recibirá puntos. ¿Estás seguro de que quieres cancelar tu registro?',
    9100031: 'Centro de Actividades de Puntos de Trading',
    9100032: 'Consigue puntos',
    9100033: 'Tienes que registrarte para participar en este evento. Haga clic para registrarse',
    9100034: 'Puedes ganar puntos operando con futuros de forma continua',
    9100035: 'Los usuarios pueden ganar puntos por todas las operaciones de futuros',
    9100036: 'Puntos de la tabla de clasificación',
    9100037: 'Los cinco mejores usuarios de las clasificaciones de operaciones diarias recibirán puntos de bonificación adicionales',
    9100038: 'Los usuarios invitados reciben puntos y el invitado puede recibir puntos de bonificación.',
    9100039: '{guy} ¡Ya ganó {num} puntos!',
    9100040: '¡Prueba el sorteo de la suerte ahora!',
    9100041: 'Enhorabuena por obtener',
    9100042: 'Todos los tipos',
    9100043: 'Quédate en esta página',
    9100044: 'Regístrese para participar',
    9100045: 'Continuar operando',
    9100046: 'Actualmente no hay actividades en curso. Por favor, siga prestando atención a las últimas noticias...',
    9100047: 'Canjear tokens SCS',
    9100048: '',
    9100049: '',

    9100050: 'Fechas',
    9100051: 'Seleccionar fecha de inicio',
    9100052: 'Seleccionar fecha de finalización',
    9100053: 'A',
    9100054: 'Tipo',

    9100055: 'Puntos ganados = volumen de negociación * 1% (la dificultad se ajustará aún más a medida que aumente el volumen total de operaciones de la plataforma)',
    9100056: 'Por ejemplo: el usuario utiliza una posición con un margen de 100 USDT*100X=10000 USDT',
    9100057: 'Entonces solo necesitas un depósito de 100 USDT para obtener 100 puntos',
    9100058: 'Los puntos de negociación son la única forma de obtener el token de la plataforma SCS',
    9100059: 'Puntos de bonificación adicionales = puntos totales para el día * relación de recompensa de clasificación',
    9100060: 'Clasificación',
    9100061: 'Primer lugar',
    9100062: 'Segundo lugar',
    9100063: 'Tercer lugar',
    9100064: 'Cuarto lugar',
    9100065: 'Quinto lugar',
    9100066: 'Los usuarios invitados reciben puntos y el invitado puede recibir puntos de bonificación.',
    9100067: 'Factor de nivel',
    9100068: 'Fórmula de cálculo: puntos de referencia obtenidos = puntos obtenidos por el invitado * coeficiente de nivel',
    9100069: 'El coeficiente de nivel se ajustará de acuerdo con la situación real',
    9100070: 'Por ejemplo: el usuario B participa en una actividad de puntos, y su invitado es el usuario A, y el número de invitaciones del usuario A ha alcanzado el nivel 3. El usuario B ha acumulado puntos = 360.000;',
    9100071: 'Luego, los puntos de promoción acumulados que el usuario A puede obtener = 360000* 30% = 108,000',
    9100072: 'Coeficiente de recompensa ',
    9100073: '1 usuario de comercio',
    9100074: 'El volumen de comercio alcanza 5 million',
    9100075: 'El volumen de comercio alcanza 20 million',

    9100076: 'Transferencia ',

    //热币
    9100080: 'Terminado',
    9100081: 'Haga clic en "Unirse ahora" para ganar recompensas',
    9100082: 'Ver reglas',
    9100083: 'Únete ahora',
    9100084: 'Activo',
    9100088: 'Comercio',
    9100089: 'Depósito',
    9100090: 'Ya te has registrado.',

    9100091: 'Este evento ha terminado, ¡espera con ansias el próximo evento!',
    9100092: 'El evento aún no ha comenzado, por favor manténgase atento.',
    9100093: '',
    9100094: '',

    //自由区二维码分享页面
    9100095: 'SuperEx Free Market, un mundo criptográfico de los usuarios, por los usuarios, para los usuarios',
    9100096: 'Abre la aplicación',
    9100097: '',
    9100098: '',
}
export default es



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/es.js